/**
 * Job Not Found 404 Component
 * Displays a 404 error page when job cannot be found
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '../../../../../components/Link';
import { Msg } from '../../../../../i18n-review/client/Msg';

export const JobNotFound404: React.FC = () => {
  const macFontStack = "font-[system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif]";
  const cardClass =
    'bg-jc-surface/90 backdrop-blur-xl rounded-2xl shadow-xl border border-jc-border px-8 py-12 flex flex-col items-center max-w-md mx-auto';

  return (
    <div
      className={`min-h-[70vh] w-full flex flex-col items-center justify-center ${macFontStack} bg-gradient-to-br from-jc-page via-jc-surface/40 to-jc-gold-bg/40 dark:from-jc-page dark:via-jc-page dark:to-jc-elevated/30`}
    >
      <div className={cardClass + ' my-12 md:my-20'} style={{ backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}>
        <span className="text-7xl md:text-8xl font-extrabold text-jc-accent mb-4 select-none" aria-label="404">
          404
        </span>
        <h1 className="text-2xl md:text-3xl font-bold text-jc-ink mb-2 text-center">
          <Msg id="jobDetailPage.404.heading" defaultMessage="This page is not found" description="Error page heading when a job is not found (404 error)" />
        </h1>
        <p className="text-jc-muted text-base text-center mb-8 max-w-xs">
          <Msg
            id="jobDetailPage.404.description"
            defaultMessage="Sorry, we couldn't find this job. It may have been removed or the link is incorrect."
            description="Error message explaining why the job page cannot be displayed"
          />
        </p>
        <Link
          href="/"
          className="px-6 py-2 rounded-full font-semibold shadow-sm bg-jc-cta text-white hover:brightness-95 active:brightness-90 transition-[filter] duration-150 mb-2"
        >
          <Msg id="jobDetailPage.404.backHome" defaultMessage="Back to Home" description="Button label to return to home page from 404 error page" />
        </Link>
      </div>
    </div>
  );
};
